import "bootstrap";
import Vue from "vue";
import App from "@/App.vue";
import jQuery from "jquery";

global.$ = jQuery; //Use it just to handler the bootstrap events

import EventBus from "@/plugins/event-bus";
Vue.use(EventBus);

new Vue({
  el: "#page",
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js